import { render, staticRenderFns } from "./CVTypeSns.vue?vue&type=template&id=1cb73042"
import script from "./CVTypeSns.vue?vue&type=script&lang=js"
export * from "./CVTypeSns.vue?vue&type=script&lang=js"
import style0 from "./CVTypeSns.vue?vue&type=style&index=0&id=1cb73042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports